<template>
  <div>
    <el-select
      v-model="dataModel"
      placeholder="请选择"
      :disabled="disabled"
      :size="size"
      :multiple="multiple"
      :clearable="clearable"
      :filterable="filterable"
      :style="`width: ${width}`"
    >
      <el-option
        v-for="(item, i) in dataList"
        :key="i"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import FormConfig from "../formConfig"; // 表单配置
// 联系人
export default {
  name: "Contacts",
  props: {
    value: {
      type: [String, Number, Array],
      default: ""
    }
  },
  data() {
    return {
      dataModel: this.value,
      size: FormConfig.config.size
    };
  },
  computed: {
    width() {
      let element = this.$parent.element || this.$parent.widget;
      let status = element.options.width || "auto";
      return status;
    },
    disabled() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.disabled;
      return status;
    },
    multiple() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.multiple;
      return status;
    },
    clearable() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.clearable;
      return status;
    },
    filterable() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.filterable;
      return status;
    },
    dataList() {
      return workFlowConfig.userList;
    }
  },
  watch: {
    value(val) {
      this.dataModel = val;
    },
    dataModel(val) {
      this.$emit("input", val);
    }
  }
};
</script>
